export const BEGIN_FETCH = 'BEGIN_FETCH';
export const FETCH_COMPLETED = 'FETCH_COMPLETED';

export const SET_CREDIT_NOTE = 'SET_CREDIT_NOTE';
export const SET_INVOICE = 'SET_INVOICE';

interface BeginFetchAction {
  type: typeof BEGIN_FETCH;
}

interface EndFetchAction {
  type: typeof FETCH_COMPLETED;
}

interface SetCreditNoteAction {
  type: typeof SET_CREDIT_NOTE;
  creditNotesPage: Record<string, unknown>;
}

interface SetInvoiceAction {
  type: typeof SET_INVOICE;
  invoiceInfo: Record<string, unknown>;
}

export type DownloadAction =
  | EndFetchAction
  | BeginFetchAction
  | SetCreditNoteAction
  | SetInvoiceAction;
